/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import OptionsSelector from "shared-components/lib/options_selector";
import { getProductImgUrl } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import { tData } from "../../../Common/utils/translation/dataUtils";
import { selectPartnerPreferences, setAxisBundleData } from "../../../Retrofit/store/slices/retrofit";
import { selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";
import ProductDataSheetLink from "../../../Common/components/Shared/ProductDataSheetLink";
import BundleItemInfo from "./BundleItemInfo";

const BundleDetails = ({ axis }) => {
  const dispatch = useDispatch();
  const partnerPreferences = useSelector(selectPartnerPreferences);
  const eventsData = useSelector(selectEventsData);

  useEffect(() => {
    dispatch(updateConfiguration());
  }, [axis.bundle.bundleData]);

  // console.log(axis);

  function fixStatus(status) {
    // console.log("fixStatus", status);
    let tmpStatus = "optional";
    if (status.trim().toLowerCase() === "mandatory") {
      tmpStatus = "mandatory";
    } else if (status.trim().toLowerCase().includes("highly")) {
      tmpStatus = "recommanded";
    } else if (status.trim().toLowerCase() === "recommended") {
      tmpStatus = "recommanded";
    }
    return tmpStatus;
  }

  const getSelectedAccessories = (accList) => {
    // console.log("getSelectedAccessories", accList);
    return accList.filter((acc) => acc.selected === true);
  };

  // eslint-disable-next-line camelcase
  const get_EAN_ENUMBER = (bundle, device) => {
    if (partnerPreferences && partnerPreferences?.preferredProductReference) {
      let preferredProductReference;
      if (partnerPreferences.preferredProductReference === "EAN") {
        preferredProductReference = "ean";
      } else if (partnerPreferences.preferredProductReference === "ENUMBER") {
        preferredProductReference = "e_num";
      }
      return bundle?.bundleData?.[device]?.translationData?.[0]?.catalogue_product?.[preferredProductReference];
    }
    return null;
  };

  const extractTypes = (types) => {
    // console.log("extractTypes", types);
    const optionTypes = [];
    if (types) {
      const typesSplited = types.split(";");
      typesSplited.forEach((type) => {
        if (type.length > 1) {
          optionTypes.push({ key: type.trim(), label: type.trim() });
        }
      });
    }
    return optionTypes;
  };

  const getSubAccessoriesOptions = (accessory) => {
    // console.log("getSubAccessoriesOptions of ", accessory);
    const subAccessories = {};
    accessory.subs.forEach((acc) => {
      subAccessories[acc.commercialReference] = {
        subAccessoryIdentification: {
          id: acc.commercialReference,
          identificationKey: acc.commercialReference
        },
        id: acc.commercialReference,
        quantity: acc.quantity,
        imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${acc.commercialReference}?width=80&height=80`,
        status: fixStatus(acc.status),
        canAdd: true,
        canIncrease: true,
        canDecrease: true,
        canRemove: true,
        optionTypes: extractTypes(acc.accessoryType),
        getOptionDescription: () => acc.mediumDescription
      };
    });

    return subAccessories;
  };

  const getSubAccessoriesModule = (accessory) => {
    // console.log("getSubAccessoriesModule of ", accessory);
    const subAccessories = [];
    accessory.subs.forEach((acc) => {
      if (acc.selected) {
        subAccessories.push({
          subAccessoryIdentification: {
            id: acc.commercialReference,
            identificationKey: acc.commercialReference
          },
          id: acc.commercialReference,
          quantity: acc.quantity,
          imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${acc.commercialReference}?width=80&height=80`,
          status: fixStatus(acc.status),
          canAdd: true,
          canIncrease: true,
          canDecrease: true,
          canRemove: true,
          description: acc.mediumDescription
        });
      }
    });

    return subAccessories;
  };

  const getDistinctAccessoryCategories = (driveAccs) => {
    // console.log("getDistinctAccessoryCategories", driveAccs);
    return driveAccs.reduce((acc, el) => {
      if (el.accessoryCategory && !acc.includes(el.accessoryCategory) && el.accessoryCategory.length > 0) {
        acc.push(el.accessoryCategory);
      }
      return acc;
    }, []);
  };

  const maxOneItemElements = [
    {
      criteria: "status",
      value: "mandatory"
    },
    {
      criteria: "accessoryCategory",
      value: "Encoder cards"
    },
    {
      criteria: "accessoryCategory",
      value: "Safety or I/O extension cards"
    }
  ];

  const onIncreaseFunc = (type, deviceIdentification, accessoryIdentification, quantity) => {
    console.log("onIncreaseFunc", type, deviceIdentification, accessoryIdentification, quantity);
    const tmpTypeAccessories = JSON.parse(JSON.stringify(axis.bundle.bundleData[type].accessories));
    const selectedElement = tmpTypeAccessories.find(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    const selectedElementIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    if (selectedElementIndex > -1) {
      // switching mandatory because delete is not allowed
      // if (selectedElement.status === "mandatory") {
      //   const currentMandatoryIndex = tmpTypeAccessories.findIndex(
      //     (element) => element.status === "mandatory" && element.selected
      //   );
      //   if (currentMandatoryIndex !== selectedElementIndex) {
      //     tmpTypeAccessories[currentMandatoryIndex] = {
      //       ...tmpTypeAccessories[currentMandatoryIndex],
      //       quantity: 0,
      //       selected: false
      //     };
      //   }
      //   // Init current mandatory subs too
      //   const parentSubAccessories = tmpTypeAccessories[currentMandatoryIndex].subs;
      //   parentSubAccessories.forEach((sub, index) => {
      //     if (sub.selected) {
      //       parentSubAccessories[index] = {
      //         ...parentSubAccessories[index],
      //         quantity: 0,
      //         selected: false
      //       };
      //     }
      //   });
      // }
      maxOneItemElements.forEach((maxOneItemElement) => {
        if (selectedElement[maxOneItemElement.criteria] === maxOneItemElement.value) {
          const currentMaxOneItemElementIndex = tmpTypeAccessories.findIndex(
            (element) => element[maxOneItemElement.criteria] === maxOneItemElement.value && element.selected
          );
          if (currentMaxOneItemElementIndex !== selectedElementIndex) {
            tmpTypeAccessories[currentMaxOneItemElementIndex] = {
              ...tmpTypeAccessories[currentMaxOneItemElementIndex],
              quantity: 0,
              selected: false
            };
          }
          // Init current element subs too
          const parentSubAccessories = tmpTypeAccessories[currentMaxOneItemElementIndex].subs;
          parentSubAccessories?.forEach((sub, index) => {
            if (sub.selected) {
              parentSubAccessories[index] = {
                ...parentSubAccessories[index],
                quantity: 0,
                selected: false
              };
            }
          });
        }
      });

      tmpTypeAccessories[selectedElementIndex] = {
        ...tmpTypeAccessories[selectedElementIndex],
        quantity: tmpTypeAccessories[selectedElementIndex].quantity + quantity,
        selected: true
      };
      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  const onDecreaseFunc = (type, deviceIdentification, accessoryIdentification, quantity) => {
    console.log("onDecreaseFunc");
    const tmpTypeAccessories = [...axis.bundle.bundleData[type].accessories];
    const selectedElementIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    if (selectedElementIndex > -1) {
      tmpTypeAccessories[selectedElementIndex] = {
        ...tmpTypeAccessories[selectedElementIndex],
        quantity: tmpTypeAccessories[selectedElementIndex].quantity - quantity,
        selected: true
      };
      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  const onRemoveFunc = (type, deviceIdentification, accessoryIdentification) => {
    console.log("onRemoveFunc");
    const tmpTypeAccessories = JSON.parse(JSON.stringify(axis.bundle.bundleData[type].accessories));
    const selectedElementIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    if (selectedElementIndex > -1) {
      tmpTypeAccessories[selectedElementIndex] = {
        ...tmpTypeAccessories[selectedElementIndex],
        quantity: 0,
        selected: false
      };

      // Dealing with subAccessories
      const parentSubAccessories = tmpTypeAccessories[selectedElementIndex].subs;
      if (parentSubAccessories.length > 0) {
        parentSubAccessories.forEach((sub, index) => {
          if (sub.selected) {
            parentSubAccessories[index] = {
              ...parentSubAccessories[index],
              quantity: 0,
              selected: false
            };
          }
        });
      }
      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  const onAddSubAccessoriesFunc = (type, deviceIdentification, accessoryIdentification, subAccessoryIdentification) => {
    console.log("onAddSubAccessoriesFunc", accessoryIdentification, subAccessoryIdentification);
    const tmpTypeAccessories = JSON.parse(JSON.stringify(axis.bundle.bundleData[type].accessories));
    const parentAccessoryIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    const parentSubAccessories = tmpTypeAccessories[parentAccessoryIndex].subs;
    const subElementIndex = parentSubAccessories.findIndex(
      (element) => element.commercialReference === subAccessoryIdentification.identificationKey
    );
    if (subElementIndex > -1) {
      parentSubAccessories[subElementIndex] = {
        ...parentSubAccessories[subElementIndex],
        quantity: parentSubAccessories[subElementIndex].quantity + 1,
        selected: true
      };

      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  const onDecreaseSubAccessoriesFunc = (
    type,
    deviceIdentification,
    accessoryIdentification,
    subAccessoryIdentification
  ) => {
    console.log("onDecreaseSubAccessoriesFunc", accessoryIdentification, subAccessoryIdentification);
    const tmpTypeAccessories = JSON.parse(JSON.stringify(axis.bundle.bundleData[type].accessories));
    const parentAccessoryIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    const parentSubAccessories = tmpTypeAccessories[parentAccessoryIndex].subs;
    const subElementIndex = parentSubAccessories.findIndex(
      (element) => element.commercialReference === subAccessoryIdentification.identificationKey
    );

    if (subElementIndex > -1) {
      parentSubAccessories[subElementIndex] = {
        ...parentSubAccessories[subElementIndex],
        quantity: parentSubAccessories[subElementIndex].quantity - 1,
        selected: true
      };
      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  const onRemoveSubAccessoriesFunc = (
    type,
    deviceIdentification,
    accessoryIdentification,
    subAccessoryIdentification
  ) => {
    console.log("onRemoveSubAccessoriesFunc", accessoryIdentification, subAccessoryIdentification);
    const tmpTypeAccessories = JSON.parse(JSON.stringify(axis.bundle.bundleData[type].accessories));
    const parentAccessoryIndex = tmpTypeAccessories.findIndex(
      (element) => element.commercialReference === accessoryIdentification.identificationKey
    );
    const parentSubAccessories = tmpTypeAccessories[parentAccessoryIndex].subs;
    const subElementIndex = parentSubAccessories.findIndex(
      (element) => element.commercialReference === subAccessoryIdentification.identificationKey
    );

    if (subElementIndex > -1) {
      parentSubAccessories[subElementIndex] = {
        ...parentSubAccessories[subElementIndex],
        quantity: 0,
        selected: false
      };
      const tmpBundleData = {
        ...axis.bundle.bundleData,
        [type]: {
          ...axis.bundle.bundleData[type],
          accessories: tmpTypeAccessories
        }
      };
      dispatch(setAxisBundleData({ axisId: axis.id, bundleData: tmpBundleData }));
    }
  };

  function doesAnyParentsExist(parents, accessories) {
    // console.log("doesAnyParentsExist", parents, accessories);
    for(const parent of parents){
      if (accessories.findIndex((acc) => acc.commercialReference === parent) !== -1) {
        return true;
      }
    }
    return false;
  }

  const getOptions = (type) => {
    console.log("getOptions");
    if (!axis.bundle.bundleData[type].accessories) return {};
    const distinctAccessoryCategories = getDistinctAccessoryCategories(axis.bundle.bundleData[type].accessories);
    const optCategories = {};
    distinctAccessoryCategories.forEach((category) => {
      optCategories[category] = {
        categoryKey: category,
        categoryLabel: category,
        isFinal: true,
        options: axis.bundle.bundleData[type].accessories.filter((element) => element.accessoryCategory === category)
          .filter((element) => !doesAnyParentsExist(element.parentsAccessories.split(";"), axis.bundle.bundleData[type].accessories))
          .map((element) => ({
            optionIdentification: {
              identificationKey: element.commercialReference,
              id: element.commercialReference
            },
            id: element.commercialReference,
            getOptionDescription: () => element.mediumDescription,
            imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${element.commercialReference}?width=80&height=80`,
            disabledMessage: "",
            canAdd: true,
            canIncrease: maxOneItemElements.every(
              (maxOneItemElement) => element[maxOneItemElement.criteria] !== maxOneItemElement.value
            ),
            canDecrease: maxOneItemElements.every(
              (maxOneItemElement) => element[maxOneItemElement.criteria] !== maxOneItemElement.value
            ),
            canRemove: element.selected && element.status !== "mandatory",
            quantity: element.quantity,
            status: fixStatus(element.status),
            optionTypes: extractTypes(element.accessoryType),
            subAccessories: getSubAccessoriesOptions(element)
          }))
      };
    });
    return {
      accessories: distinctAccessoryCategories.length > 0 ? [{ optionCategories: optCategories }] : []
    };
  };

  const extractModule = (type, id) => {
    console.log("extractModule", type, id);
    if (!axis.bundle.bundleData[type].accessories) return [];
    const selectedAccessories = getSelectedAccessories(axis.bundle.bundleData[type].accessories);
    return [
      {
        deviceIdentification: {
          identificationKey: id,
          moduleId: id
        },
        id,
        description: "",
        imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${id}?width=80&height=80`,
        selectedOptions: {
          accessories: selectedAccessories.map((selectedElement) => ({
            optionIdentification: {
              identificationKey: selectedElement.commercialReference,
              id: selectedElement.commercialReference
            },
            id: selectedElement.commercialReference,
            quantity: selectedElement.quantity ? selectedElement.quantity : 1,
            description: selectedElement.mediumDescription,
            status: fixStatus(selectedElement.status),
            type: selectedElement.accessoryCategory,
            filterStatusOnEdit: selectedElement.status === "mandatory" ? "mandatory" : null,
            canShowInModal: true,
            disablePreviousOnEdit: true,
            // canIncrease: selectedElement.status !== "mandatory" && selectedElement.accessoryCategory !== "Encoder cards",
            canIncrease: maxOneItemElements.every(
              (maxOneItemElement) => selectedElement[maxOneItemElement.criteria] !== maxOneItemElement.value
            ),

            canDecrease: maxOneItemElements.every(
              (maxOneItemElement) => selectedElement[maxOneItemElement.criteria] !== maxOneItemElement.value
            ),
            canRemove: selectedElement.status !== "mandatory",
            subAccessories: getSubAccessoriesModule(selectedElement),
            onIncrease: (deviceIdentification, accessoryIdentification, quantity) =>
              onIncreaseFunc(type, deviceIdentification, accessoryIdentification, quantity),
            onDecrease: (deviceIdentification, accessoryIdentification, quantity) =>
              onDecreaseFunc(type, deviceIdentification, accessoryIdentification, quantity),
            onRemove: (deviceIdentification, accessoryIdentification) =>
              onRemoveFunc(type, deviceIdentification, accessoryIdentification)
          }))
        },
        onAddSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification) =>
          onAddSubAccessoriesFunc(type, deviceIdentification, accessoryIdentification, subAccessoryIdentification),
        onDecreaseSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification) =>
          onDecreaseSubAccessoriesFunc(type, deviceIdentification, accessoryIdentification, subAccessoryIdentification),
        onRemoveSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification) =>
          onRemoveSubAccessoriesFunc(type, deviceIdentification, accessoryIdentification, subAccessoryIdentification)
      }
    ];
  };

  const mapToStringWithSeparator = (map, separator = "|") => {
    // console.log("mapToStringWithSeparator");
    const itemComponents = [];
    const entries = Array.from(map.entries());
    // eslint-disable-next-line no-restricted-syntax
    for (const entry of entries) {
      const [key, value] = entry;
      itemComponents.push(<BundleItemInfo infoKey={key} infoValues={value} key={key} />);
      if (entry !== entries[entries.length - 1]) {
        itemComponents.push(<span className="text-gray-700">{separator}</span>);
      }
    }
    return <div className="flex flex-row items-start gap-4 font-light text-sm">{itemComponents}</div>;
  };

  const generatekeyValueDescription = (type) => {
    // console.log("generatekeyValueDescription");
    const descElements = new Map();
    switch (type) {
      case "motor":
        descElements.set(t("msizer.ui.nominal_torque"), [
          `${axis.bundle.bundleData?.nominalTorqueOfMotor}
        ${t("msizer.ui.unit.nm")}`
        ]);
        descElements.set(t("msizer.ui.nominal_speed"), [
          `${axis.bundle.bundleData?.nominalSpeedOfMotor} ${t("msizer.ui.unit.rpm")}`
        ]);
        descElements.set(t("msizer.ui.motor_filters.inertia"), [
          `${axis.bundle.bundleData?.motor?.inertiaMotor} ${t("msizer.ui.unit.kg_cm_squared")}`
        ]);
        break;
      case "drive":
        descElements.set(t("msizer.ui.drive_filters.supply_voltage"), [axis.bundle.bundleData?.drive?.outputVoltages]);
        descElements.set(t("msizer.ui.drive_filters.output_current"), [
          axis.bundle.bundleData?.drive?.outputCurrents?.toString()
        ]);
        descElements.set(t("msizer.ui.drive_filters.line_current"), [
          `${axis.bundle.bundleData?.drive?.lineCurrent || "-"} A`
        ]);
        break;
      case "gearbox":
        descElements.set(t("msizer.ui.gearbox_filters.short_name"), [
          `${tData("gearbox", "family", axis.bundle.bundleData?.gearbox?.family)}`
        ]);
        descElements.set(t("msizer.ui.gearbox_filters.reduction_ratio"), [
          `${axis.bundle.bundleData?.gearbox?.reductionRatio}:1`
        ]);
        descElements.set(t("msizer.ui.efficiency"), [`${axis.bundle.bundleData?.gearbox?.efficiency}%`]);
        break;
      case "adaptationkit":
        // adaptationkit data
        break;
      default:
    }
    return descElements;
  };

  const styledProductDataSheetLink = (idLabel, eventTag, reference, preferredReference, ean) => (
    <div className="flex flex-col flex-1 ml-2">
      <div
        className="font-bold text-xs print:text-xxs print:underline hover:underline text-secondary hover:text-darksecondary"
        rel="noreferrer"
      >
        <ProductDataSheetLink idLabel={idLabel} eventTag={eventTag} reference={reference} />
      </div>
      {(preferredReference || ean) && (
        <span className="text-xs text-gray-600">
          <span className="font-semibold">{preferredReference}</span>
          {ean}
        </span>
      )}
    </div>
  );

  function getAndReplace(key, data) {
    // console.log("getAndReplace");
    const label = t(key);
    return label.replace(/({.*})/gi, data);
  }

  return (
    <div className="md:flex flex-col mx-2 mb-2 px-2 shadow bg-white">
      {["drive", "motor", "gearbox", "adaptationKit"].map((type) => {
        const descElements = generatekeyValueDescription(type);
        return (
          axis.bundle[`${type}Reference`] && (
            <OptionsSelector
              key={type}
              moduleCategories={[
                {
                  displayType: "flat",
                  categoryName: t(`msizer.ui.${type}`),
                  moduleItems: [
                    {
                      moduleId: axis.bundle[`${type}Reference`],
                      imageUrl: getProductImgUrl(axis.bundle[`${type}Reference`]),
                      renderDescriptionComponent: () => mapToStringWithSeparator(descElements),
                      deviceIdentification: {
                        identificationKey: axis.bundle[`${type}Reference`]
                      },
                      optionsAvailable: {
                        accessories: axis.bundle.bundleData[type].accessories
                      },
                      preventCardDisabledWhenNoOptions: true,
                      modules: extractModule(type, axis.bundle[`${type}Reference`]),
                      getOptions: () => getOptions(type),
                      onAddOptions: (deviceIdentification, accessoryIdentification, quantity) =>
                        onIncreaseFunc(type, deviceIdentification, accessoryIdentification, quantity),
                      onDecreaseOptions: (deviceIdentification, accessoryIdentification, quantity) =>
                        onDecreaseFunc(type, deviceIdentification, accessoryIdentification, quantity),
                      onRemoveOptions: (deviceIdentification, accessoryIdentification) =>
                        onRemoveFunc(type, deviceIdentification, accessoryIdentification),
                      onAddSubAccessories: (
                        deviceIdentification,
                        accessoryIdentification,
                        subAccessoryIdentification
                      ) =>
                        onAddSubAccessoriesFunc(
                          type,
                          deviceIdentification,
                          accessoryIdentification,
                          subAccessoryIdentification
                        ),
                      onDecreaseSubAccessories: (
                        deviceIdentification,
                        accessoryIdentification,
                        subAccessoryIdentification
                      ) =>
                        onDecreaseSubAccessoriesFunc(
                          type,
                          deviceIdentification,
                          accessoryIdentification,
                          subAccessoryIdentification
                        ),
                      onRemoveSubAccessories: (
                        deviceIdentification,
                        accessoryIdentification,
                        subAccessoryIdentification
                      ) =>
                        onRemoveSubAccessoriesFunc(
                          type,
                          deviceIdentification,
                          accessoryIdentification,
                          subAccessoryIdentification
                        )
                    }
                  ]
                }
              ]}
              renderProductLink={(reference) =>
                styledProductDataSheetLink(
                  `${type}-${axis.id}`,
                  eventsData.tags.specifySelectCompare,
                  reference,
                  partnerPreferences?.preferredProductReference,
                  get_EAN_ENUMBER(axis.bundle, type)
                )
              }
              getLabel={(key) => t(`msizer.ui.${key}`)}
              getAndReplaceLabel={(key, value) => getAndReplace(`msizer.ui.${key}`, value)}
              mobileBreakpoint={800}
            />
          )
        );
      })}
    </div>
  );
};

BundleDetails.propTypes = {
  axis: PropTypes.any.isRequired
};

export default BundleDetails;
